export default {
	"exceptionType": {
		"typeName": "type name",
		"type": "type",
		"autoMonitor": "automatic monitoring",
		"exceptionCode": "exception code",
		"code": "code",
		"attr": "attributes",
		"level": "level",
		"tabTitle1": "type information",
		"defaultLevel": "default level",
		"hourLimit": "processing time limit",
		"reason": "abnormal",
		"reasonName": "reason name",
		"addTitle": "create exception type"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/exceptionType/exceptionType.js